module.exports = __webpack_public_path__ + "img/splash_image-footer.0fea5d05.jpg";